import { CreditCard } from 'lucide-react'
import { ManageBillingButton } from '@/components/shared/manage-billing-button'
import { H3 } from '@/components/sv/typographies'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'

export const ManageBilling = () => {
  return (
    <Card className="bg-secondary p-0 gap-0">
      <CardHeader className="px-5 pt-3 pb-1">
        <CardTitle>
          <H3 className="flex items-center gap-2 text-sm text-muted-foreground">
            <CreditCard className="size-4" /> Billing & payment methods
          </H3>
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0 flex-1">
        <Card className="p-0 border-x-0 border-b-0 shadow-none h-full">
          <CardHeader className="pt-6">
            <CardDescription>
              Manage your payment methods, billing address, invoices, and VAT
              details
            </CardDescription>
          </CardHeader>
          <CardContent className="pb-6">
            <ManageBillingButton />
          </CardContent>
        </Card>
      </CardContent>
    </Card>
  )
}
